// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NicheTable {
  display: flex;
}
.NicheTable [class^=BaseTable-tableHead] th:first-child {
  display: none;
}
.NicheTable [class^=BaseTable-numberSection] {
  display: none;
}
.NicheTable [class^=BaseTable-tableBody],
.NicheTable [class^=BaseTable-tableHead] {
  grid-template-columns: 40px 320px minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
}
.NicheTable [class^=BaseTable-title] {
  height: auto;
}
.NicheTable .FavoriteTerritoryCell {
  display: none;
}
.NicheTable .FavoriteTerritoryCell:has(.FavoriteButton--isSaved) {
  display: inherit;
}
.NicheTable tr {
  padding: 12px 12px 12px 8px;
  height: 64px;
}
.NicheTable tr:hover .FavoriteTerritoryCell {
  display: inherit;
}
.NicheTable tr:hover .TableTitleWithCheckbox-checkboxContainer .TableTitleWithCheckbox-index {
  display: none;
}
.NicheTable tr:hover .TableTitleWithCheckbox-checkboxContainer .TerritoryAddToCheckbox {
  display: inherit;
}`, "",{"version":3,"sources":["webpack://./src/modules/niche/niche-table/niche-table.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,aAAA;AACJ;AAEE;EACE,aAAA;AAAJ;AAGE;;EAEE,6FAAA;AADJ;AAIE;EACE,YAAA;AAFJ;AAKE;EACE,aAAA;AAHJ;AAME;EACE,gBAAA;AAJJ;AAOE;EACE,2BAAA;EACA,YAAA;AALJ;AASI;EACE,gBAAA;AAPN;AAWM;EACE,aAAA;AATR;AAYM;EACE,gBAAA;AAVR","sourcesContent":[".NicheTable {\n  display: flex;\n\n  [class^='BaseTable-tableHead'] th:first-child {\n    display: none;\n  }\n\n  [class^='BaseTable-numberSection'] {\n    display: none;\n  }\n\n  [class^='BaseTable-tableBody'],\n  [class^='BaseTable-tableHead'] {\n    grid-template-columns: 40px 320px minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);\n  }\n\n  [class^='BaseTable-title'] {\n    height: auto;\n  }\n\n  .FavoriteTerritoryCell {\n    display: none;\n  }\n\n  .FavoriteTerritoryCell:has(.FavoriteButton--isSaved) {\n    display: inherit;\n  }\n\n  tr {\n    padding: 12px 12px 12px 8px;\n    height: 64px;\n  }\n\n  tr:hover {\n    .FavoriteTerritoryCell {\n      display: inherit;\n    }\n\n    .TableTitleWithCheckbox-checkboxContainer {\n      .TableTitleWithCheckbox-index {\n        display: none;\n      }\n\n      .TerritoryAddToCheckbox {\n        display: inherit;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
